import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Select,
  Tabs,
  message,
} from "antd";
import { NavLink, useNavigate } from "react-router-dom";
import { signupCompany } from "../../api/api";
import SuccessModal from "../modal/SuccessModal";
import { getAllISOCodes } from "iso-country-currency";
import { default as ReactSelect } from "react-select";
import axiosInstance from "../../utils/axiosInstance";
import { useTheme } from "../../utils/themeToggle/theme";

const { Option } = Select;
const { TabPane } = Tabs;

const SignupComponent = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState("+91");
  const [country, setCountry] = useState();
  const [states, setStates] = useState([]);
  const [allCurrency, setAllCurrency] = useState([]);
  const [userType, setUserType] = useState("professional"); // "user" or "professional"
  const { reactSelectTheme } = useTheme();

  const handleCountryChange = (countryId) => {
    const selectedCountry = countries.find((c) => c.id === countryId);
    const code = selectedCountry?.country_code || "+91";
    setCountryCode(code);
    setCountry(countryId);
    fetchStates(countryId);
  };

  const fetchStates = async (countryId) => {
    try {
      const response = await axiosInstance.get("/state/get/", {
        customParams: {
          country_id: countryId,
        },
      });
      setStates(response.data);
    } catch (error) {
      console.error("Failed to fetch states");
    }
  };

  const onFinish = async (values) => {
    const address = {
      country: parseInt(values.country),
    };
    try {
      setIsLoading(true);
      const response = await signupCompany({
        name: values.companyName,
        admin_email: values.email,
        admin_contact_number: values.phone,
        first_name: values.userName,
        address,
        currency: values.currency?.value,
        user_type: userType,
        role: userType === "user" ? "Admin" : "professional",
      });
      console.log(response, "after API call");
      // if (response.status === 201) {
      setIsModal(true);
      message.success("Company created successfully.");
      navigate("/auth/login");
      // } else {
      // console.log(response, "in else block");
      // message.error(
      //   response?.data?.error || "Signup failed. Please try again."
      // );
      // }
    } catch (err) {
      console.log(err?.error?.error[0], "in catch");
      const errorMessage =
        err?.error?.error[0] ||                           // Axios ka default msg
        "Something went wrong.";

      // fallback

      console.log(errorMessage, "complete error");

      message.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };


  const onClickDemo = () => {
    navigate("/auth/demo-request/");
  };

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const res = await axiosInstance.get(`/country/get/`);
        setCountries(res.data);
      } catch (error) {
        console.error("Failed to load countries");
      }
    };

    const fetchCurrency = async () => {
      try {
        const codes = await getAllISOCodes();
        const options = codes.map((code) => ({
          value: `${code.countryName} (${code.symbol})`,
          label: `${code.countryName} (${code.symbol})`,
        }));
        setAllCurrency(options);
      } catch (error) {
        console.error("Currency fetch failed");
      }
    };

    fetchCountry();
    fetchCurrency();
  }, []);



  return (
    <>
      {isModal && (
        <SuccessModal
          modal="true"
          message="User created successfully. A link has been sent to your email to reset your password."
          link="/auth/login"
        />
      )}

      <div className="glass-card shadow-lg rounded-lg p-6 sm:p-10 max-w-xl bg-white/30 text-[#0c1634] backdrop-blur-sm">
        <div className="flex justify-start mb-5 border-b-[2px] border-gray-150">
          <button
            onClick={() => setUserType("user")}
            className={`px-4 py-2 w-1/2 font-medium ${userType === "user"
              ? " border border-1 broder-gray-200 rounded-tl-lg rounded-tr-lg bg-white text-[#122253] shadow-md"
              : " "
              }`}
          >
            User
          </button>
          <button
            onClick={() => setUserType("professional")}
            className={`px-4 py-2 w-1/2 font-medium ${userType === "professional"
              ? " border border-1 broder-gray-200 rounded-tl-lg rounded-tr-lg bg-white text-[#122253] shadow-md"
              : ""
              }`}
          >
            Professional
          </button>
        </div>


        <h2 className="text-xl font-bold text-center text-white mb-2">
          Sign Up as {userType === "user" ? "User" : "Professional"}
        </h2>

        <Form layout="vertical" onFinish={onFinish}>
          {/* Row 1 */}
          <div className="flex flex-col md:flex-row gap-4">
            <Form.Item
              name="userName"
              label="User Name"
              className="w-full"
              rules={[{ required: true, message: "Please enter your name" }]}
            >
              <Input placeholder="Enter user name" />
            </Form.Item>

            <Form.Item
              name="companyName"
              label="Company Name"
              className="w-full"
              rules={[{ required: true, message: "Please enter company name" }]}
            >
              <Input placeholder="Enter company name" />
            </Form.Item>
          </div>

          {/* Row 2 */}
          <div className="flex flex-col md:flex-row gap-4">
            <Form.Item
              name="email"
              label="Email Address"
              className="w-full"
              rules={[{ required: true, message: "Please enter a valid email" }]}
            >
              <Input type="email" placeholder="Enter email address" />
            </Form.Item>

            <Form.Item
              name="country"
              label="Country"
              className="w-full"
              rules={[{ required: true, message: "Please select country" }]}
            >
              <Select
                showSearch
                placeholder="Select country"
                onChange={handleCountryChange}
                optionFilterProp="children"
              >
                {countries.map((country) => (
                  <Option key={country.id} value={country.id}>
                    {country.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          {/* Row 3 */}
          <div className="flex flex-col md:flex-row gap-4">
            {userType === "user" && (
              <Form.Item
                name="currency"
                label="Base Currency"
                className="w-full"
                rules={[{ required: true, message: "Please select currency" }]}
              >
                <ReactSelect
                  options={allCurrency}
                  styles={reactSelectTheme}
                />
              </Form.Item>
            )}


            <Form.Item
              name="phone"
              label="Contact Number"
              className="w-full"
              rules={[{ required: true, message: "Please enter contact number" }]}
            >
              <Input
                addonBefore={countryCode}
                placeholder="Enter contact number"
              />
            </Form.Item>
          </div>

          <Form.Item
            name="agree"
            valuePropName="checked"
            rules={[{ required: true, message: "You must accept terms" }]}
          >
            <Checkbox>
              I have read and agree to the Terms and Privacy Policy
            </Checkbox>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={isLoading}
              style={{
                backgroundColor: "#122253",
                borderColor: "#122253",
                borderRadius: "6px",
              }}
            >
              {isLoading ? "Signing up..." : "Sign Up"}
            </Button>
          </Form.Item>

          <div className="text-center text-sm">
            Already a user?{" "}
            <NavLink to="/auth/login" className="text-[#122253] font-semibold">
              Log in
            </NavLink>
          </div>

          <div className="text-center mt-4">
            <button
              onClick={onClickDemo}
              className="glass-card text-[#122253] px-3 py-2"
            >
              Request a Demo
            </button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default SignupComponent;
